// CDN image optimizer via images.weserv.nl (free proxy CDN with auto WebP, resize, quality)
// Usage:
//   <img src={cdnImg(url, { w: 1200 })} srcSet={cdnSrcSet(url)} sizes="100vw" />

const WESERV = 'https://images.weserv.nl/';

/**
 * Wrap any public http(s) image URL through weserv with WebP + resize.
 * @param {string} url - Original image URL
 * @param {object} opts - { w, h, q, fit }
 * @returns {string} Optimized URL (or original if not http(s))
 */
export const cdnImg = (url, opts = {}) => {
  if (!url || typeof url !== 'string') return url;
  if (!/^https?:\/\//i.test(url)) return url;

  const { w, h, q = 78, fit = 'cover', a } = opts;
  const stripped = url.replace(/^https?:\/\//i, '');
  const params = new URLSearchParams();
  params.set('url', stripped);
  if (w) params.set('w', String(w));
  if (h) params.set('h', String(h));
  params.set('q', String(q));
  params.set('output', 'webp');
  params.set('we', ''); // never enlarge beyond original
  if (fit) params.set('fit', fit);
  if (a) params.set('a', a);
  return `${WESERV}?${params.toString()}`;
};

/**
 * Build a responsive srcSet string at common breakpoints.
 */
export const cdnSrcSet = (url, widths = [480, 800, 1200, 1600, 1920]) => {
  if (!url || typeof url !== 'string' || !/^https?:\/\//i.test(url)) return undefined;
  return widths.map((w) => `${cdnImg(url, { w })} ${w}w`).join(', ');
};
